export default __webpack_public_path__ + "static/media/satti-logo3.1f98bb99.jpeg";